import styled, { css, DefaultTheme } from 'styled-components';
import { memoizeFunction } from '@agilepoint/utils-common';
import { DropdownState } from '../theme';
import { FlexBox } from '../../flex-box';

interface IDropdownField extends React.HTMLProps<HTMLDivElement> {
    $error?: boolean;
    $disabled?: boolean;
    $showOptions: boolean;
}

const getDropdownFieldStylesByState = memoizeFunction((state: DropdownState) => {
    const getStyles = (theme: DefaultTheme) => {
        const { dropdown: { colors } } = theme;
        return colors[state];
    };
    return css`
        background-color: ${({ theme }) => getStyles(theme).fieldBackgroundColor};
        border-color: ${({ theme }) => getStyles(theme).fieldBorderColor};
        color: ${({ theme }) => getStyles(theme).fieldTextColor};
        outline: 0;
    `;
});

export const DropdownField = styled(FlexBox).attrs(({ $disabled }: any) => ({
    className: String('ap-dropdown-field'),
    tabIndex: $disabled? -1 : 0
})) <IDropdownField>`
    ${({ $error, $disabled }) => ($disabled ? getDropdownFieldStylesByState('disabled') : (getDropdownFieldStylesByState($error ? 'error' : 'default')))};
    cursor: ${({ $disabled }) => ($disabled ? 'not-allowed' : 'pointer')};
    box-sizing: border-box;
    border-radius: ${({ theme: { dropdown: { composites } } }) => composites.fieldBorderRadius};
    border-style: solid;
    border-width: ${({ theme: { dropdown: { composites } } }) => composites.fieldBorderWidth};
    height: 100%;
    width: 100%;
    padding: ${({ theme: { semantics: { gap } } }) => `${gap.none} ${gap.xl}`};
    position: relative;
    vertical-align: middle;
    text-overflow: ellipsis;
    
    &:hover {
        ${({ $error, $disabled }) => ($disabled ? getDropdownFieldStylesByState('disabled') : (getDropdownFieldStylesByState($error ? 'error' : 'hovered')))};
    }
    &:focus, &:active {
        ${({ $error, $disabled }) => ($disabled ? getDropdownFieldStylesByState('disabled') : (getDropdownFieldStylesByState($error ? 'error' : 'focused')))};
    }
    `;
